import React from 'react'
import CarstayText from '../../../assets/brands/CarstayText.svg'
import styles from './Login.scss'

const Logo = () => <div className="text-center">
  <CarstayText className={styles.carstayLogo}/>
</div>
Logo.displayName = 'Logo'
export default Logo
